import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=7310b968&"
import script from "./Checkbox.vue?vue&type=script&lang=ts&"
export * from "./Checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports